import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';
import { useTheme } from '@mui/material';
import { useMytaverse } from '@providers/MytaverseProvider';
import { TabletSize } from '@features/TrainerTools/constants';

export const useStyles = () => {
  const { breakpoints } = useTheme();
  const { appTheme } = useMytaverse();

  const scroll = {
    '&::-webkit-scrollbar': {
      height: '5px',
      width: '5px',
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: colors.silver,
      borderRadius: '2px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: appTheme.mainColor,
      borderRadius: '2px',
      boxShadow: 'unset',
    },
  };

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      height: '100%',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 2,
      [breakpoints.down(TabletSize)]: {
        flexDirection: 'column',
      },
    },
    title: {
      fontSize: 32,
      fontFamily: 'var(--primary-font-bold)',
      lineHeight: 1,
      letterSpacing: '0.02em',
      color: colors.white,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 26,
      },
    },
    filter: {
      display: 'flex',
      gap: 1,
      flexWrap: 'wrap',
      maxHeight: 90,
      overflowY: 'auto',
      ...scroll,
    },
    list: {
      display: 'flex',
      gap: 3,
      flexWrap: 'wrap',
      height: 558,
      maxHeight: '45vh',
      alignItems: 'flex-start',
      alignContent: 'flex-start',
      overflowY: 'auto',
      ...scroll,

      [breakpoints.down(ScreenSizes.PcWide)]: {
        maxHeight: '40dvh',
      },

      [breakpoints.down(ScreenSizes.PcLarge)]: {
        gap: 2,
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        gap: 1.5,
      },
    },
    actions: {
      display: 'flex',
      gap: 4,
      mt: 'auto',
      '& button': { flex: 1 },

      [breakpoints.down(ScreenSizes.PcWide)]: {
        gap: 2,
      },

      [breakpoints.down(TabletSize)]: {
        flexDirection: 'column',
      },
    },
    group: {
      // marginTop: isOffline ? 1 : 0,
      marginBottom: 1,
      paddingY: 1,
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      '&:before': {
        content: '""',
        height: '1px',
        flexGrow: 1,
        backgroundColor: colors.grey_second,
      },
      '&:after': {
        content: '""',
        height: '1px',
        flexGrow: 1,
        backgroundColor: colors.grey_second,
      },
    },
    groupName: {
      fontSize: 14,
      lineHeight: '24px',
      textAlign: 'center',
      color: colors.white,
      fontWeight: 500,
      paddingX: 2,
    },
    search: {
      width: 236,
    },
    text: {
      color: colors.white,
      textAlign: 'center',
      fontSize: 14,
      width: '100%',
    },
  };
};
